"use client";
import "../chunk-GOCCUU3Z.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslText } from "@getpara/react-components";
import styled from "styled-components";
import { CenteredColumnContainer, FullWidthFilledDisabledInput, CenteredText } from "./common.js";
import { QRCode } from "./QRCode.js";
import { getDeviceLogo, getDeviceModelName } from "../utils/index.js";
import { useCopyToClipboard } from "../hooks/index.js";
const KnownDevices = ({ hints, link, showCurrentDevice }) => {
  const [isCopied, copy] = useCopyToClipboard();
  const handleCopy = () => {
    copy(link);
  };
  return /* @__PURE__ */ jsxs(Container, { children: [
    /* @__PURE__ */ jsx(CenteredText, { weight: "semiBold", children: "Continue with one of your other known devices" }),
    !!hints.formattedHints.length && /* @__PURE__ */ jsx(DevicesContainer, { children: hints.formattedHints.map(
      (hint) => {
        var _a, _b, _c;
        return (showCurrentDevice && hint.isKnownDevice || !hint.isKnownDevice) && /* @__PURE__ */ jsxs(DeviceListItem, { children: [
          /* @__PURE__ */ jsx(DeviceLogo, { icon: getDeviceLogo(hint.device.vendor, hint.isMobile) }),
          /* @__PURE__ */ jsx(CpslText, { weight: "medium", color: "contrast", children: (_b = (_a = getDeviceModelName(hint.device.model)) != null ? _a : hint.device.vendor) != null ? _b : hint.os.name }),
          (hint.browser || hint.passwordManager) && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(CpslText, { weight: "medium", color: "secondary", children: "using" }),
            /* @__PURE__ */ jsx(CpslText, { weight: "medium", color: "contrast", children: (_c = hint.passwordManager) != null ? _c : hint.browser.name })
          ] })
        ] }, hint.key);
      }
    ) }),
    hints.hasMobileDevice ? /* @__PURE__ */ jsx(QRCode, { link, icon: "paraIconQr" }) : /* @__PURE__ */ jsxs(CenteredColumnContainer, { children: [
      /* @__PURE__ */ jsx(FullWidthFilledDisabledInput, { noAutoDisable: true, readonly: true, disabled: true, value: link, children: /* @__PURE__ */ jsx(CpslButton, { slot: "end", variant: "ghost", onClick: handleCopy, children: /* @__PURE__ */ jsx(CpslIcon, { icon: isCopied ? "check" : "copy" }) }) }),
      /* @__PURE__ */ jsx(CenteredText, { color: "secondary", variant: "bodyS", weight: "medium", children: "Navigate to this link using your other device" })
    ] })
  ] });
};
const Container = styled(CenteredColumnContainer)`
  gap: 16px;
`;
const DevicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--cpsl-color-background-4);
  padding: 16px;
  width: 100%;
  border-radius: 16px;
`;
const DeviceListItem = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;
const DeviceLogo = styled(CpslIcon)`
  --icon-color: var(--cpsl-color-text-contrast);
  --height: 16px;
  --width: 16px;
`;
export {
  KnownDevices
};
